import React, { ChangeEvent } from 'react';

export type DropdownMenuProps = {
  id: string;
  label: string;
  items: Array<{
    title: string;
    value: number | string;
  }>;
  onChange?: (event: ChangeEvent<HTMLSelectElement>) => void;
  onMouseDown?: (event: React.MouseEvent<HTMLSelectElement>) => void;
  selectedValue?: number | string;
  className?: string;
};

export const DropdownMenu = (props: DropdownMenuProps): JSX.Element => {
  const { className, id, items, label, onChange, onMouseDown, selectedValue } = props;

  return (
    <div className='block'>
      <label htmlFor={id} className='text-gray-500 text-sm font-normal pl-2'>
        {label}
      </label>
      <div
        className={`rounded-full border border-gray-300 bg-white shadow-md${className ? ` ${className}` : ''}`}
      >
        <select
          id={id}
          value={selectedValue}
          onChange={onChange}
          onMouseDown={onMouseDown}
          className='rounded-full bg-transparent outline-none border-0 text-sm md:text-md md:pr-10 w-full md:w-auto'
        >
          {items.map((item) => (
            <option key={item.value} value={item.value}>
              {item.title}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};
